class cSueldos {
  constructor(id, name, intCod, strCod, cat, ws) {
    this.id = id;
    this.name = name;
    this.intCod = intCod;
    this.strCod = strCod;
    this.cat = cat;
    this.ws = ws;
  }
  static fromJson({
    csueldoId,
    nombre,
    sueldosIntCod,
    sueldosStrCod,
    cat,
    ws,
  }) {
    return new cSueldos(
      csueldoId,
      nombre,
      sueldosIntCod,
      sueldosStrCod,
      cat,
      ws
    );
  }
}
export default cSueldos;
